import { useState } from 'react';

export const usePagination = (defaultSize = 20) => {
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(defaultSize);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPageItems, setCurrentPageItems] = useState(0);

  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setPage(newPage);
    }
  };

  const handleJumpPages = (direction) => {
    const jumpSize = 5;
    if (direction === 'forward') {
      const newPage = Math.min(page + jumpSize, totalPages - 1);
      setPage(newPage);
    } else if (direction === 'backward') {
      const newPage = Math.max(page - jumpSize, 0);
      setPage(newPage);
    }
  };

  const setPageListItems = (e) => {
    const value = parseInt(e.target.getAttribute('data-value'));
    setSize(value);
    setPage(0);
  };

  const getPageNumbers = () => {
    const maxVisiblePages = 5; // Number of pages to show before using ellipsis
    const pageNumbers = [];
    
    if (totalPages <= maxVisiblePages) {
      // If total pages is less than max visible, show all pages
      for (let i = 0; i < totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always show first page
      pageNumbers.push(0);
      
      if (page > 2) {
        pageNumbers.push('...');
      }
      
      // Show pages around current page
      for (let i = Math.max(1, page - 1); i <= Math.min(page + 1, totalPages - 2); i++) {
        pageNumbers.push(i);
      }
      
      if (page < totalPages - 3) {
        pageNumbers.push('...');
      }
      
      // Always show last page
      if (totalPages > 1) {
        pageNumbers.push(totalPages - 1);
      }
    }
    
    return pageNumbers;
  };

  return {
    page,
    size,
    total,
    totalPages,
    currentPageItems,
    setPage,
    setSize,
    setTotal,
    setTotalPages,
    setCurrentPageItems,
    handlePageChange,
    handleJumpPages,
    setPageListItems,
    getPageNumbers
  };
}; 
